import React, { useState } from "react";
import { Form, FormLabel, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { editJefe } from "../../redux/Headcount/SessionNotification/actions";

const CheckColaboradores = (props) => {
  const [loading, setLoading] = useState(false);
  // const [isChecked, setIsChecked] = useState(props.value.requerido);

  const dispatch = useDispatch();

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    const req = {
      colaboradores: checked,
      clasificacion: props.value.clasificacion,
    };
    dispatch(editJefe(req, props.value.id, props.index, setLoading));
  };
  return (
    <>
      {/* {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : ( */}
      <div className="d-flex flex-wrap justify-content-start align-items-center">
        {/* <FormLabel className="mb-0 text-muted" for={`check ${props.value.id}`}>
          {isChecked ? "Si" : "No"}
        </FormLabel> */}
        <Form.Check
          id={`check colaboradores ${props.value.id}`}
          name={`check colaboradores ${props.value.id}`}
          onChange={handleCheckbox}
          className="ml-2 rounded-pill"
          type="switch"
          defaultChecked={props.value.colaboradores}
        />
      </div>
      {/* )} */}
    </>
  );
};

export default CheckColaboradores;
